import Upload from "../../widgets/Upload";

// function Upload(){
    
//     return(
//         <Upload></Upload>
//     )
// }

function Loader(){

}

export default Upload;
export { Loader };
